// extracted by mini-css-extract-plugin
export default {"detailForm":"RecordingDetails_detailForm__7-3Bj"};